import { render } from "./TrustedBy.vue?vue&type=template&id=db73d670&scoped=true"
import script from "./TrustedBy.vue?vue&type=script&lang=js"
export * from "./TrustedBy.vue?vue&type=script&lang=js"

import "./TrustedBy.vue?vue&type=style&index=0&id=db73d670&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-db73d670"

export default script